"use client"
import { notFound } from "next/navigation";
import { memo } from "react";
import OverlayTransitionWrapper from "@/components/overlay-transition-wrapper/overlay-transition-wrapper";
import StoriesPage from "@/components/stories/stories-page";
import StoryLayout from "@/components/story/story-layout";

function StoryPage({ ugcStories, storyParam }) {
  const story = ugcStories.find(storyData => storyData.slug === storyParam);

  if (!story) {
    notFound();
  }

  return (
    <OverlayTransitionWrapper
      backgroundContent={
        <StoriesPage ugcStories={ugcStories} isDummy={true} />
      }
      overlayContent={
        <div className="w-full font-sans page">
          <StoryLayout
            content={story}
            slug={story.slug}
            stories={ugcStories}
            theme="main-dark"
          />
        </div>
      }
      mainContent={
        <div className="w-full font-sans page">
          <StoryLayout
            content={story}
            slug={story.slug}
            stories={ugcStories}
            theme="main-dark"
          />
        </div>
      }
    />
  )
}

export default memo(StoryPage)
